import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

@Pipe({
  name: "generateServices",
  standalone: true,
})
export class ServicesPipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(value: Record<string, boolean>): string {
    const services: string[] = [];

    const serviceCategories = {
      restaurant: ["restaurant"],
      shop: ["shop_snackbar"],
      toilet: ["shower", "toilet"],
      fuel: [
        "diesel_fuel",
        "truck_diesel",
        "bio_diesel",
        "high_performance_diesel",
        "red_diesel_heating_oil",
        "hvo_100",
        "hvo_blend",
        "petrol_95",
        "petrol_premium",
        "petrol_e10",
        "bio_ethanol_e85",
        "compressed_natural_gas",
        "liquefied_natural_gas",
        "liquefied_petroleum_gas",
        "hydrogen",
      ],
      washing: ["truck_wash", "car_wash", "bus_wash", "vacuum_cleaner"],
    };

    Object.keys(serviceCategories).forEach((service: string) => {
      const fields =
        serviceCategories[service as keyof typeof serviceCategories];
      for (const field of fields) {
        if (value[field]) {
          const label = this.translocoService.translate(
            "manage_location.service_details." + service,
          );
          services.push(label);
          break;
        }
      }
    });

    return services.join(", ");
  }
}
